export const CHARACTER_QUOTES = {
    casca: "Thinking about it, it's been years since I last wore a skirt... and I'm so much more muscular now.",
    charlotte: "We earnestly entreat all of you to join us now as we devote ourselves to the recapture of our land.",
    conrad: "Bring the child to the altar.",
    corkus: "Welll, I'm the one who taught him the word, y'see. Besides, he's a fag anyway.",
    farnese: "The master of the sinful black sheep, the king of the blind white sheep.",
    femto: "Yes, you're nothing but a squirming, sacrificial offering.",
    flora: "People may appear to repeat the same mistakes, but karma is by no means a circle. Indeed, it is a spiral.",
    ganishka: "No, with my own blood-drenched hands, I will take and desecrate god.",
    godot: "Tell this to that fool. 'Don't turn out like me'.",
    griffith: "It seems, I am, free.",
    guts: 'He died doing what he wanted, no matter what, right? I bet he was happy.',
    isidro: "You're better off not watchin' the people you knew gettin' hacked up.",
    isma: "I can get dressed look...",
    judeau: "You sure do cry a lot, you know.",
    mozgus: "The lord doth revere silence.",
    pippin: "Drink.",
    puck: "Hey. Don't say that. Without me, this story'd be way too dark. You gotta have a little color in your life...",
    rickert: "The falcon of light, is not my commander.",
    roderick: "She's not the kind of woman who's at peace within the schemes of men.",
    schierke: "He who dons that armor and aligns with ominous flow of od dwelling therein truly becomes a savage.",
    serpico: "Allies infected with fear are worse than enemies.",
    skullknight: "Struggle, contend, wriggle! That alone is the sword of one who confronts death!",
    slan: "Let it all loose.",
    ubik: "An unpredictable thing happens at the temporal junction point. Albeit an extremely minute thing...",
    vargas: "In those days the count was a different person. He was cruel but at least he was still human.",
    void: "All lies within the currents of causality.",
    zodd: "You'll face your death. A death you can't escape!"
}